module.exports = __webpack_public_path__ + "static/img/mis.a63cea5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mis.png
// module id = GUcq
// module chunks = 2